import ContinuePage from "@components/ContinuePage"

export default function CarsWhyCarsProfilePage() {
  return <ContinuePage emoji="🏁" translationKey="carsWhyCarsProfile" />
}
